// Extract the server's error message from an axios error. API error bodies are
// `{ error: <message>, result, status: 0 }` (controllerHelper.sendError / the
// auth middlewares), so prefer that over axios's generic "Request failed…".
export default function getApiErrorMessage(err: any, fallback: string): string {
  const serverMessage = err?.response?.data?.error;
  return (typeof serverMessage === 'string' && serverMessage) || fallback;
}
